export default {
  manage: {
    label: 'Guided tours',
    desc: 'Manage guided tours',
    reset: 'Replay the guided tour',
    completed: 'Completed',
    pristine: 'Not started',
    activate: 'Enable guided tours',
    deactivateInfo: 'You can access your account settings to reactivate all guided tours.'
  },
  buttons: {
    next: 'Continue',
    prev: 'Back',
    done: 'Close the guided tour',
    deactivate: 'Disable tours'
  },
  tour: {
    patient: {
      header: {
        serviceTitle: 'Your care service',
        serviceDesc: 'This service is responsible for your medical support. It centralises your information, coordinates your care and shares useful documents or messages regarding your health journey.',
        notificationsTitle: 'Notification center',
        notificationsDesc: 'View your new notifications related to your follow-up.',
        profileTitle: 'Profile and settings',
        profileDesc: 'Access your account information and settings.'
      },
      tabs: {
        label: 'Patient space tabs',
        tasksTitle: 'My Tasks',
        tasksDesc: 'Your daily actions to complete.',
        monitoringTitle: 'My Monitoring',
        monitoringDesc: 'Your follow-up and your measurements.',
        agendaTitle: 'My Agenda',
        agendaDesc: 'Your appointments and events.',
        messengerTitle: 'My Messages',
        messengerDesc: 'Chat with the care team.',
        documentsTitle: 'My Documents',
        documentsDesc: 'All your documents.'
      },
      tasks: {
        label: 'My tasks',
        title: 'My tasks',
        desc: 'Find here your actions to complete: questionnaires, appointments and documents to consult.',
        counterTitle: 'Task counter',
        counterDesc: 'The number of scheduled activities for today and the number of free activities.',
        priorityTitle: 'Priority',
        priorityDesc: 'The most important or overdue actions appear here.',
        todayTitle: 'Scheduled today',
        todayDesc: 'The actions scheduled for today appear here.',
        upcomingTitle: 'Upcoming',
        upcomingDesc: 'Your next scheduled actions appear here.',
        freeTitle: 'Free activities',
        freeDesc: 'Optional questionnaires you can complete at any time.',
        cleanupAlert: 'The demo task data has been deleted.',
        congratsTitle: 'Congratulations!',
        congratsDesc: 'You have completed the guided tour of the tasks. You can now use this section independently.'
      },
      events: {
        label: 'My agenda',
        title: 'My agenda',
        desc: 'View your scheduled questionnaires, appointments and documents for the selected date.',
        schedulerTitle: 'Calendar',
        schedulerDesc: 'Select a date to display the activities planned for that day.',
        listTitle: 'Day activities',
        listDesc: 'View your questionnaires, appointments and scheduled documents for this date.',
        addTitle: 'Add an activity',
        addDesc: 'Schedule a questionnaire, an appointment or add a reminder for a given date.',
        cleanupAlert: 'The demo agenda data has been deleted.',
        outroTitle: 'Congratulations!',
        outroDesc: 'You now know how to use your agenda.'
      },
      documents: {
        label: 'My documents',
        title: 'My documents',
        desc: 'Find your personal documents and the resources shared by the team.',
        filterTitle: 'Search filters',
        filterDesc: 'If you have a lot of documents, refine the display using the search and sorting tools.',
        listTitle: 'Document list',
        listDesc: 'Tap a document to open, view or download it.',
        addTitle: 'Add a document',
        addDesc: 'Upload a file or take a photo to add it to your documents.',
        cleanupAlert: 'The demo document data has been deleted.',
        outroTitle: 'Congratulations!',
        outroDesc: 'You now know where to find your documents.'
      },
      messages: {
        label: 'My messages',
        title: 'My messages',
        desc: 'Chat with your care team, view and send messages.',
        addTitle: 'Send a message',
        addDesc: 'Write your message, attach a file if needed, then tap Send.',
        cleanupAlert: 'The demo messaging data has been deleted.',
        outroTitle: 'Congratulations!',
        outroDesc: 'You now know how to use the messaging.'
      },
      monitoring: {
        label: 'My monitoring',
        title: 'My monitoring',
        desc: 'View your measurements, educational content and history.',
        graphsTitle: 'My data',
        graphsDesc: 'Find your recent measurements displayed as charts.',
        contentTitle: 'Therapeutic content',
        contentDesc: 'Videos, articles and documents to support you.',
        historyTitle: 'History',
        historyDesc: 'Your recent actions: questionnaire responses and document consultations.',
        cleanupAlert: 'The demo monitoring data has been deleted.',
        outroTitle: 'Congratulations!',
        outroDesc: 'You now know where to find your monitoring.'
      },
      home: {
        label: 'Home page',
        welcomeTitle: 'Welcome to Aptelecare!',
        welcomeDesc: 'We will guide you through the features of your patient space so you can follow your health information with ease and peace of mind.\n\n**Some sample data may appear, don’t worry: it will be automatically removed at the end of the tour**.',
        countersTitle: 'Activity overview',
        countersDesc: 'Easily track your progress: view your tasks to complete, new messages and documents shared by your medical team.',
        tasksTitle: 'My Tasks',
        tasksDesc: 'Find here the actions to complete: questionnaires, appointments and documents to consult.',
        monitoringTitle: 'My Monitoring',
        monitoringDesc: 'View your measurements and the progress of your follow-up.',
        documentsTitle: 'My Documents',
        documentsDesc: 'Access your medical documents.',
        messagesTitle: 'My Messages',
        messagesDesc: 'Communicate safely with the care team.',
        agendaTitle: 'My Agenda',
        agendaDesc: 'Your appointments and events.',
        outroTitle: 'Congratulations!',
        outroDesc: 'You now know your patient space. Feel free to come back regularly to track your health information and stay in touch with your medical team.'
      },
      fakeData: {
        // Events
        eventsFollowupFormName: 'Follow-up questionnaire',
        eventsFollowupFormLaterName: 'Follow-up questionnaire (later)',
        eventsRendezVousTitle: 'Phone appointment',
        eventsRendezVousDescription: 'With your assigned nurse.',
        eventsFreeFormOptionalName: 'Weekly follow-up questionnaire (optional)',
        eventsFreeFormName: 'Weekly follow-up questionnaire',
        eventsPlannedDocumentName: 'Information document',
        eventsPlannedDocumentFileName: 'Preparation guide',
        eventsFollowupFormTomorrowName: 'Follow-up questionnaire (tomorrow)',

        // Graphs
        graphsBpTitle: 'Blood pressure',
        graphsIndicatorSystolicName: 'Systolic',
        graphsIndicatorDiastolicName: 'Diastolic',
        graphsWeightTitle: 'Weight',
        graphsIndicatorWeightName: 'Weight',

        // Messages
        messagesWelcome: 'Hello, welcome to your secure messaging. Feel free to ask your questions.',
        messagesQuestion: 'Thank you! Should I complete the questionnaire today?',
        messagesAnswer: 'Yes, you can complete it now.',

        // Documents
        document1: 'Video: Preparing for my appointment',
        document2: 'Brochure: Practical information',
        document3: 'Article: Daily advice',

        // Therapeutic content
        therapeuticContent1: 'Guide: Understanding my follow-up',
        therapeuticContent2: 'Video: Breathing and relaxation',

        // History
        historyFormName: 'Follow-up questionnaire'
      }
    }
  }
}
